import { briefingApi } from '@/apis';
import { useQuery } from '@tanstack/react-query';

export function useAssociatedVehicle(occurrenceCode) {
  return useQuery({
    queryKey: ['associatedVehicle', occurrenceCode],
    queryFn: () => {
      return briefingApi
        .get(`niche/occurrences/${occurrenceCode}?entity=vehicle`, {
          timeout: false,
        })
        .json();
    },
    enabled: !!occurrenceCode,
    staleTime: 30 * (60 * 1000),
    cacheTime: 35 * (60 * 1000),
  });
}
